import { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import IconDiesel from '@/assets/icons/icon-diesel.svg?react';
import IconOther from '@/assets/icons/icon-other.svg?react';
import IconSolar from '@/assets/icons/icon-solar.svg?react';
import IconWind from '@/assets/icons/icon-wind.svg?react';
import { GenerationTypeKey } from '@/types/plant';

type GenerationOptionType = {
  label: string;
  value: GenerationTypeKey;
  icon: ReactNode;
};

type GenerationType = {
  wind: GenerationOptionType;
  solar: GenerationOptionType;
  diesel: GenerationOptionType;
  other: GenerationOptionType;
};

const useGenerationTypes = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const generationTypes: GenerationType = {
    wind: {
      label: t('plants.form.mechanicalProps.generationTypes.wind'),
      value: 'wind',
      icon: <IconWind fill={theme.colors.greenPale} />,
    },
    solar: {
      label: t('plants.form.mechanicalProps.generationTypes.solar'),
      value: 'solar',
      icon: <IconSolar fill={theme.colors.yellowAccent} />,
    },
    diesel: {
      label: t('plants.form.mechanicalProps.generationTypes.diesel'),
      value: 'diesel',
      icon: <IconDiesel fill={theme.colors.bluePrimary} />,
    },
    other: {
      label: t('plants.form.mechanicalProps.generationTypes.other'),
      value: 'other',
      icon: <IconOther fill={theme.colors.grayPrimary} />,
    },
  };

  return generationTypes;
};

export default useGenerationTypes;
